import { supabase } from '../lib/supabase';

export const fetchShopHours = async () => {
  const { data } = await supabase.from('shop_hours').select('*').order('day_of_week', { ascending: true });
  return data || [];
};

export const toggleShopHourOpen = async (id, current) => {
  await supabase.from('shop_hours').update({ is_open: !current }).eq('id', id);
};

export const updateShopHourTime = async (id, field, value) => {
  await supabase.from('shop_hours').update({ [field]: value }).eq('id', id);
};

export const fetchHolidays = async () => {
  const { data } = await supabase.from('shop_holidays').select('*').order('start_date', { ascending: true });
  return data || [];
};

export const insertHoliday = async (payload) => {
  const { error } = await supabase.from('shop_holidays').insert([payload]);
  if (error) throw error;
};

export const deleteHoliday = async (id) => {
  await supabase.from('shop_holidays').delete().eq('id', id);
};

export const fetchRetentionDays = async () => {
  const { data } = await supabase
    .from('shop_settings').select('value').eq('key', 'photo_retention_days').single();
  return data?.value;
};

export const fetchLunchBreak = async () => {
  const { data } = await supabase.from('shop_settings').select('key,value')
    .in('key', ['lunch_break_enabled','lunch_break_start','lunch_break_end']);
  const m = Object.fromEntries((data || []).map(r => [r.key, r.value]));
  return { enabled: m.lunch_break_enabled === 'true', start: m.lunch_break_start || '12:00', end: m.lunch_break_end || '13:00' };
};

export const saveLunchBreak = async ({ enabled, start, end }) => {
  const { error } = await supabase.from('shop_settings').upsert([
    { key: 'lunch_break_enabled', value: String(enabled) },
    { key: 'lunch_break_start',   value: start },
    { key: 'lunch_break_end',     value: end },
  ], { onConflict: 'key' });
  if (error) throw error;
};

export const saveRetentionDays = async (val) => {
  const { error } = await supabase.from('shop_settings').upsert(
    { key: 'photo_retention_days', value: String(val), description: '예약 사진 자동 삭제 기준 (예약일 기준 N일 후)' },
    { onConflict: 'key' }
  );
  if (error) throw error;
};
